var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "guidance_box" }, [
    _c(
      "div",
      { staticClass: "head_box" },
      [
        _vm._m(0),
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.enterYwtFn } },
          [_vm._v("进入业务定制系统")]
        )
      ],
      1
    ),
    _c("div", { staticClass: "content_box" }, [
      _c("ul", { staticClass: "list_ul" }, [
        _c("li", { staticClass: "list_li" }, [
          _c("p", { staticClass: "li_title" }, [_vm._v("双方录入")]),
          _c(
            "div",
            { staticClass: "li_card" },
            [
              _c(
                "el-carousel",
                {
                  staticClass: "carousel",
                  attrs: { trigger: "click", height: "450px", autoplay: false }
                },
                _vm._l(_vm.imgList1, function(item, index) {
                  return _c(
                    "el-carousel-item",
                    { key: index, staticStyle: { "text-align": "center" } },
                    [
                      _c("img", {
                        staticStyle: { "max-width": "100%", height: "450px" },
                        attrs: { src: item.src, alt: "" }
                      })
                    ]
                  )
                }),
                1
              ),
              _vm._m(1)
            ],
            1
          )
        ]),
        _c("li", { staticClass: "list_li" }, [
          _c("p", { staticClass: "li_title" }, [_vm._v("前置业务首页")]),
          _c(
            "div",
            { staticClass: "li_card" },
            [
              _c(
                "el-carousel",
                {
                  staticClass: "carousel",
                  attrs: { trigger: "click", height: "450px", autoplay: false }
                },
                _vm._l(_vm.imgList2, function(item, index) {
                  return _c(
                    "el-carousel-item",
                    { key: index, staticStyle: { "text-align": "center" } },
                    [
                      _c("img", {
                        staticStyle: { "max-width": "100%", height: "450px" },
                        attrs: { src: item.src, alt: "" }
                      })
                    ]
                  )
                }),
                1
              ),
              _vm._m(2)
            ],
            1
          )
        ]),
        _c("li", { staticClass: "list_li" }, [
          _c("p", { staticClass: "li_title" }, [_vm._v("批量业务模板发起")]),
          _c(
            "div",
            { staticClass: "li_card" },
            [
              _c(
                "el-carousel",
                {
                  staticClass: "carousel",
                  attrs: { trigger: "click", height: "450px", autoplay: false }
                },
                _vm._l(_vm.imgList3, function(item, index) {
                  return _c(
                    "el-carousel-item",
                    { key: index, staticStyle: { "text-align": "center" } },
                    [
                      _c("img", {
                        staticStyle: { "max-width": "100%", height: "450px" },
                        attrs: { src: item.src, alt: "" }
                      })
                    ]
                  )
                }),
                1
              ),
              _vm._m(3)
            ],
            1
          )
        ]),
        _c("li", { staticClass: "list_li" }, [
          _c("p", { staticClass: "li_title" }, [_vm._v("业务模板管理")]),
          _c(
            "div",
            { staticClass: "li_card" },
            [
              _c(
                "el-carousel",
                {
                  staticClass: "carousel",
                  attrs: { trigger: "click", height: "450px", autoplay: false }
                },
                _vm._l(_vm.imgList4, function(item, index) {
                  return _c(
                    "el-carousel-item",
                    { key: index, staticStyle: { "text-align": "center" } },
                    [
                      _c("img", {
                        staticStyle: { "max-width": "100%", height: "450px" },
                        attrs: { src: item.src, alt: "" }
                      })
                    ]
                  )
                }),
                1
              ),
              _vm._m(4)
            ],
            1
          )
        ])
      ]),
      _c(
        "div",
        { staticStyle: { "text-align": "center" } },
        [
          _c(
            "el-button",
            {
              staticStyle: { width: "80%" },
              attrs: { type: "primary" },
              on: { click: _vm.enterYwtFn }
            },
            [_vm._v("进入业务定制系统")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head_left" }, [
      _c("img", {
        staticClass: "img",
        attrs: { src: require("../../static/images/logoNew.png"), alt: "" }
      }),
      _c("span", { staticClass: "span" }, [_vm._v("业务定制系统操作指引")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card_right" }, [
      _c("p", { staticClass: "right_title" }, [
        _vm._v(
          "可按需配置电子合同模板，合同模板支持单、双方录入签约信息，同时支持针对签约方身份信息核验、签署意愿认证等。"
        )
      ]),
      _c("div", { staticClass: "row_box" }, [
        _c("div", { staticClass: "row_once" }, [
          _c("div", { staticClass: "radio" }, [_vm._v("1")]),
          _c("div", { staticClass: "col" }, [
            _c("p", { staticClass: "col_p" }, [_vm._v("合同模板配置：")]),
            _c("span", [
              _vm._v(
                "按照业务需求配置模板，设置模板样式、录入方数量、签署方是否固定及签章、归档设置等。"
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "row_once" }, [
          _c("div", { staticClass: "radio" }, [_vm._v("2")]),
          _c("div", { staticClass: "col" }, [
            _c("p", { staticClass: "col_p" }, [_vm._v("设置合同变量：")]),
            _c("span", [
              _vm._v(
                "按照业务需求配置模板所需填写的变量，支持文本、数字、日期、证件号码、下拉选项、多选、表格等多种变量配置。在配置变量时需选择录入方，在发起时由选择好的录入方填写对应变量信息。"
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "row_once" }, [
          _c("div", { staticClass: "radio" }, [_vm._v("3")]),
          _c("div", { staticClass: "col" }, [
            _c("p", { staticClass: "col_p" }, [_vm._v("设置签署方信息：")]),
            _c("span", [
              _vm._v(
                "填写签署方信息，支持设置顺序签署、短信签署、审批流程、抄送等配置项，签署方信息支持变量填入。"
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "row_once" }, [
          _c("div", { staticClass: "radio" }, [_vm._v("4")]),
          _c("div", { staticClass: "col" }, [
            _c("p", { staticClass: "col_p" }, [_vm._v("立即发起：")]),
            _c("span", [
              _vm._v(
                "合同发起后，根据模板设置，由指定签约方录入对应信息，录入完成后合同正式发起，各方在指定的签约位置完成签署。"
              )
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card_right" }, [
      _c("p", { staticClass: "right_title" }, [
        _vm._v(
          "可根据用户需求自定义创建前置业务首页，集业务展示、分类浏览、电子合同签署、费用支付为一体，灵活多变，操作简单。"
        )
      ]),
      _c("div", { staticClass: "row_box" }, [
        _c("div", { staticClass: "row_once" }, [
          _c("div", { staticClass: "radio" }, [_vm._v("1")]),
          _c("div", { staticClass: "col" }, [
            _c("p", { staticClass: "col_p" }, [_vm._v("创建前置业务首页：")]),
            _c("span", [
              _vm._v(
                "按照业务需求，创建业务首页，可按需添加合同模板、外部链接、认证链接等。"
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "row_once" }, [
          _c("div", { staticClass: "radio" }, [_vm._v("2")]),
          _c("div", { staticClass: "col" }, [
            _c("p", { staticClass: "col_p" }, [_vm._v("集成业务首页：")]),
            _c("span", [
              _vm._v(
                "可将业务首页链接集成至自有业务系统中，或将链接二维码放至业务页面、海报、三折页中，便于客户了解业务，快速成单。"
              )
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card_right" }, [
      _c("p", { staticClass: "right_title" }, [
        _vm._v(
          "\n                  支持业务模板批量发起，多个业务模板相同变量一次录入，全模板可用，无需重复填写，省时省力。"
        )
      ]),
      _c("div", { staticClass: "row_box" }, [
        _c("div", { staticClass: "row_once" }, [
          _c("div", { staticClass: "radio" }, [_vm._v("1")]),
          _c("div", { staticClass: "col" }, [
            _c("p", { staticClass: "col_p" }, [_vm._v("创建公共变量：")]),
            _c("span", [
              _vm._v(
                "点击新增创建公共变量，支持多种变量类型，一次创建，多模板可用，无需重复创建填写，省时省力。"
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "row_once" }, [
          _c("div", { staticClass: "radio" }, [_vm._v("2")]),
          _c("div", { staticClass: "col" }, [
            _c("p", { staticClass: "col_p" }, [_vm._v("创建合同：")]),
            _c("span", [
              _vm._v(
                "点击新增创建批量签合同模板，支持单/双方录入，支持海量变量设置及签署方设置。"
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "row_once" }, [
          _c("div", { staticClass: "radio" }, [_vm._v("3")]),
          _c("div", { staticClass: "col" }, [
            _c("p", { staticClass: "col_p" }, [_vm._v("创建业务：")]),
            _c("span", [_vm._v("选择业务模板，将所选择的模板组成批量签业务")])
          ])
        ]),
        _c("div", { staticClass: "row_once" }, [
          _c("div", { staticClass: "radio" }, [_vm._v("4")]),
          _c("div", { staticClass: "col" }, [
            _c("p", { staticClass: "col_p" }, [_vm._v("立即发起：")]),
            _c("span", [
              _vm._v(
                "合同发起后，根据模板设置，相同变量一次录入，减少重复操作。"
              )
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card_right" }, [
      _c("p", { staticClass: "right_title" }, [
        _vm._v(
          "\n                  通过可视化界面即可自由搭建匹配业务流程的模板体系，像拼搭专属“业务流程图”一样，轻松将纸质流程转化为数字化模板。"
        )
      ]),
      _c("div", { staticClass: "row_box" }, [
        _c("div", { staticClass: "row_once" }, [
          _c("div", { staticClass: "radio" }, [_vm._v("1")]),
          _c("div", { staticClass: "col" }, [
            _c("p", { staticClass: "col_p" }, [_vm._v("创建业务分类：")]),
            _c("span", [
              _vm._v(
                "通过分类，将不同的模板进行归纳整理，同时可按分类将模板授权给不同的成员使用。"
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "row_once" }, [
          _c("div", { staticClass: "radio" }, [_vm._v("2")]),
          _c("div", { staticClass: "col" }, [
            _c("p", { staticClass: "col_p" }, [_vm._v("业务模板管理：")]),
            _c("span", [
              _vm._v(
                "支持模板的增删改查，可直接发起，也可生成签署二维码，同时支持将模板快速授权及下载。"
              )
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a5562690", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5562690","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/ywtRelated/guidancePage.vue
// module id = T91y
// module chunks = 136